import { WeaverLoading } from 'Components'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Button, List, Input, Select, Switch, Tag, Popover, Tooltip } from 'antd'
import { X, Plus, Search as SearchIcon } from 'react-feather'
import './Entities.scss'

{ Search } = Input

export default ({
  addEntity,
  allEntities,
  comparator,
  entityFilter,
  getEntities,
  refreshOnFocus = false,
  removeEntity,
  setWriteAccess,
  sortBy,
  title,
  titleRenderer
}) -> ({ item, isActive }) ->

  [loading, setLoading] = useState(true)
  [entities, setEntities] = useState([])
  [entitiesWithoutAccess, setEntitiesWithoutAccess] = useState([])
  [filterValue, setFilterValue] = useState("")
  [isAdding, setIsAdding] = useState(false)
  [dropdownOpen, setDropdownOpen] = useState(false)

  loadEntities = ->
    setLoading(true)
    setEntities(await getEntities(item))
    setLoading(false)

  useEffect(->
    (-> loadEntities() )()
    undefined
  , [item])

  useEffect(->
    (-> if (isActive and refreshOnFocus) then loadEntities() )()
    undefined
  , [isActive])

  useEffect(->
    (->
      setEntitiesWithoutAccess(
        _.sortBy(_.differenceBy(await allEntities(), entities, comparator), sortBy)
      )
    )()
    undefined
  , [entities])

  useEffect(->
    if isAdding
      setDropdownOpen(true)
  , [isAdding])

  if loading
    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      <WeaverLoading style={{ width: '10%' }}/>
    </div>
  else
    <>
      <div style={{
        display: 'flex'
        flexDirection: 'row'
        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.05)',
        padding: '16px'
      }}>
        {
          if addEntity?
            <Tooltip title={
              if isAdding
                "Search #{title}"
              else
                "Add #{title}"
            }>
              <Button style={{ marginRight: '16px' }}
                      data-testid="add-item"
                      type="link"
                      onClick={->
                        setIsAdding(not isAdding)
                      }
              >
                <span className="anticon">
                  {
                    if isAdding
                      <SearchIcon width="1.5em" height="1.5em" />
                    else
                      <Plus width="1.5em" height="1.5em" />
                  }
                </span>
              </Button>
            </Tooltip>
        }
        {
          if isAdding
            <Select placeholder="Select #{ title } to add"
                    data-testid="search-add-item"
                    open={dropdownOpen}
                    onDropdownVisibleChange={(open) ->
                      setDropdownOpen(open)
                    }
                    onSelect={(value, { entity }) ->
                      setEntities(_.sortBy([
                        entities...
                        await addEntity(item, entity)
                      ], sortBy))
                   }
                   style={{ width: '100%' }}
                   filterOption={(value, { entity }) ->
                     entityFilter(value, entity)
                   }
                   showSearch
               >
                 {
                   entitiesWithoutAccess.map((entity) ->
                     <Select.Option key={entity.id()} entity={entity}>{ titleRenderer(entity) }</Select.Option>
                   )
                 }
            </Select>
          else
            <Search placeholder="Filter #{ title }"
                data-testid="search-item"
                onChange={({ target: { value }}) ->
                  setFilterValue(value)
                } />
        }
      </div>
      <div style={{ padding: '0px 16px', flex: '1 1 auto', overflow: 'auto', minHeight: '0px' }}>
        <List
          itemLayout="horizontal"
          className='entity-list'
          dataSource={_.sortBy(_.filter(entities, (entity) -> entityFilter(filterValue, entity)), sortBy)}
          size="small"
          renderItem={(entity) ->
            tooltip = (
              if entity.hasRoleWriteAccess
                "Write access given through user group"
              else if entity.hasPublicWriteAccess or entity.hasPublicReadAccess
                "Space is public"
              else if entity.hasRoleReadAccess
                "Read access given through user group")

            actions = []
            if removeEntity?
              actions.unshift(
                <Tooltip placement="left" title={tooltip}>
                  <Button type="link"
                          disabled={entity.cannotRevoke}
                          danger
                          onClick={->
                            await removeEntity(item, entity)
                            setEntities(entities.filter((e) ->
                              entity.id() isnt e.id()
                            ))
                          }
                          icon={<span className="anticon anticon-btn"><X width="1em" height="1em" /></span>}
                  />
                </Tooltip>
              )

            if setWriteAccess?
              actions.unshift(
                <Tooltip placement="left" title={tooltip}>
                  <Switch defaultChecked={entity.hasWriteAccess}
                          disabled={entity.cannotChangePermissions}
                          checkedChildren="Write"
                          onChange={(checked) ->
                            setWriteAccess(item, entity, checked)
                          }
                          unCheckedChildren="Read" />
                </Tooltip>
              )

            <List.Item key={entity.id()} actions={actions}>
              <List.Item.Meta
                title={<><Link to="/acl/#{title}/#{entity.id()}">{ titleRenderer(entity) }</Link> { <Tag color="green">Public</Tag> if entity.hasPublicReadAccess }</>}
              />
            </List.Item>
          }
        />
      </div>
    </>
